// extracted by mini-css-extract-plugin
export default {"statscontainer":"DataCards_statscontainer__zRBZO","statcard":"DataCards_statcard__7oTJe","statlabel":"DataCards_statlabel__yF30V","statvalue":"DataCards_statvalue__xxsfK"};